<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Adventures of Sherlock Bones</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#sherlock-bones-and-the-creepy-castle">Sherlock Bones and The Creepy Castle</a>
<ol>
<li id="toc-li-6"><a href="#/text/ch006#chapter-one">Chapter One</a></li>
<li id="toc-li-7"><span href="#/text/ch007#chapter-two" title="Link target outside of Sample">Chapter Two</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-three" title="Link target outside of Sample">Chapter Three</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-four" title="Link target outside of Sample">Chapter Four</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-five" title="Link target outside of Sample">Chapter Five</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-six" title="Link target outside of Sample">Chapter Six</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-seven" title="Link target outside of Sample">Chapter Seven</span></li>
</ol>
</li>
<li id="toc-li-13"><span href="#/text/ch013#around-the-isles-in-eight-ways" title="Link target outside of Sample">Around the Isles in Eight Ways</span>
<ol>
<li id="toc-li-14"><span href="#/text/ch014#chapter-one-1" title="Link target outside of Sample">Chapter One</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-two-1" title="Link target outside of Sample">Chapter Two</span>
</li>
<li id="toc-li-17"><span href="#/text/ch016#chapter-three-1" title="Link target outside of Sample">Chapter Three</span></li>
<li id="toc-li-18"><span href="#/text/ch017#chapter-four-1" title="Link target outside of Sample">Chapter Four</span></li>
<li id="toc-li-19"><span href="#/text/ch018#chapter-five-1" title="Link target outside of Sample">Chapter Five</span></li>
<li id="toc-li-20"><span href="#/text/ch019#chapter-six-1" title="Link target outside of Sample">Chapter Six</span></li>
<li id="toc-li-21"><span href="#/text/ch020#chapter-seven-1" title="Link target outside of Sample">Chapter Seven</span></li>
<li id="toc-li-22"><span href="#/text/ch021#chapter-eight" title="Link target outside of Sample">Chapter Eight</span></li>
</ol>
</li>
<li id="toc-li-23"><span href="#/text/ch022#travel-route-and-mileages" title="Link target outside of Sample">Travel Route and Mileages</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?1f0371c8